import SpreeAPIOrderAdapter from './ams-adapters/spree-api-order-adapter';

const request = require('superagent');

const UserAPI = {
    // Get User
    getUser: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        return request.get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/account`)
            .set('Authorization', `Bearer ${params.token}`)
            .query(sanitizedQueryParams)
            .send();
    },

    // Login
    login: (params) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/spree_oauth/token`)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send(`grant_type=password&username=${params.email}&password=${params.password}`),

    // Login
    loginByCode: (params) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/otp/check-code`)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send(`email=${params.email}&otp_code=${params.otp_code}`),

    // Login
    sendCodeByEmail: (params) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/otp/send-code`)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send(`email=${params.email}`),

    // Refresh
    refreshToken: (refreshToken) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/spree_oauth/token`)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send(`grant_type=refresh_token&refresh_token=${refreshToken}`),

    // Signup
    signup: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        return request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/account`)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .send(params.data);
    },

    // Register user by email
    registerByEmail: (params) => {
        const sanitizedQueryParams = {
            locale: params.locale,
        };
        return request.get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/account_confirmations/${params.tokens}`)
            .query(sanitizedQueryParams);
    },

    // Send Forgot Password Email
    sendEmail: (data) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/passwords`)
        .set('Content-Type', 'application/vnd.api+json')
        .send(data),

    // Send Forgot Password Email
    forgotPassword: (data, token) => request.patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/passwords/${token}`)
        .set('Content-Type', 'application/vnd.api+json')
        .send(data),

    // Set account valid age
    setAccountAgeValid: (data, accessToken) => request
        .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/account/set_age_valid`)
        .set('Authorization', `Bearer ${accessToken}`)
        .field('age_valid', data.age_valid)
        .then((response) => response),
};

export default UserAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/user.js
 **/